var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"player"},[(_vm.transcoded === false && _vm.url)?_c('div',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.trans('Video is still being transcoded. Please try again in a few minutes.')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }